import React, { Component } from "react";
import FooterNavButton from "./FooterNavButton";

class Pagination extends Component {
  constructor(props) {
    super(props);

    this.state = {
      compress: false,
      isMobileView: window.innerWidth < 768
    };
  }

  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);

    if (this.state.isMobileView || this.props.isCompress) {
      this.setState({ compress: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isCompress !== this.props.isCompress) {
      if (this.props.isCompress) {
        this.setState({ compress: true });
      }
    }
  }

  handleResize = () => {
    const mobile = window.innerWidth < 768;
    this.setState({ isMobileView: mobile });

    if (mobile) {
      this.setState({ compress: true });
    }
  };

  handlePageClick = (newPage) => {
    const count = this.props.count || 0;
    const rowsPerPage = this.props.rowsPerPage || 25;
    const totalPages = Math.max(1, Math.ceil(count / rowsPerPage));

    if (newPage >= 1 && newPage <= totalPages) {
      this.props.onPageChange(newPage);
    }
  };

  renderPaginationButtons = () => {
    const { page = 1, count = 0, rowsPerPage = 25 } = this.props;
    const { compress } = this.state;

    const totalPages = Math.max(1, Math.ceil(count / rowsPerPage));

    return (
      <div
        style={{
          display: "flex",
          gap: "4px",
          justifyContent: compress ? "center" : "flex-start",
          marginTop: compress ? "0" : "0"
        }}
      >
        {/* First */}
        <FooterNavButton
          type="leftarrowdouble"
          label="First"
          disabled={page === 1}
          onClick={() => this.handlePageClick(1)}
        />

        {/* Previous */}
        <FooterNavButton
          type="leftarrow"
          label="Previous"
          disabled={page === 1}
          onClick={() => this.handlePageClick(page - 1)}
        />

        {/* Numbers */}
        {[...Array(Math.min(5, totalPages))].map((_, i) => {
          const pageNum = page > 3 ? page - 3 + i + 1 : i + 1;

          if (pageNum <= totalPages) {
            return (
              <FooterNavButton
                key={pageNum}
                type="text"
                label={pageNum}
                active={page === pageNum}
                onClick={() => this.handlePageClick(pageNum)}
              />
            );
          }
          return null;
        })}

        {/* Next */}
        <FooterNavButton
          type="rightarrow"
          label="next"
          onClick={() => this.handlePageClick(page + 1)}
          disabled={page >= totalPages}
        />

        {/* Last */}
        <FooterNavButton
          type="rightarrowdouble"
          label="Last"
          onClick={() => this.handlePageClick(totalPages)}
          disabled={page >= totalPages}
        />
      </div>
    );
  };

  render() {
    const {
      count = 0,
      page = 1,
      rowsPerPage = 25,
      onRowsPerPageChange
    } = this.props;

    const { compress } = this.state;

    const startRow = (page - 1) * rowsPerPage + 1;
    const endRow = Math.min(page * rowsPerPage, count);

    const containerStyle = {
      background: "rgba(255,255,255,0.7)",
      padding: "16px",
      borderRadius: "0 0 12px 12px",
      border: "1px solid #f3f4f6",
      height: compress ? "auto" : "50px"
    };

    const selectStyle = {
      border: "1px solid #e5e7eb",
      borderRadius: "8px",
      marginRight: "12px",
      padding: "8px",
      backgroundColor: "#ffffff",
      cursor: "pointer",
      fontSize: "14px"
    };

    const infoTextStyle = {
      fontSize:compress ? "12px" : "14px",
      color: "#6b7280"
    };

    const flexBetweenStyle = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "100%"
    };

    const flexCenterStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "16px"
    };

    const leftSectionStyle = {
      display: "flex",
      alignItems: "center"
    };

    return (
      <div style={containerStyle}>
        {compress ? (
          <>
            <div style={flexCenterStyle}>
              <select
                style={selectStyle}
                value={rowsPerPage}
                onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
              >
                {[25, 50, 100].map((size) => (
                  <option key={size} value={size}>
                    {size} per page
                  </option>
                ))}
              </select>

              {count > 0 && (
                <span style={infoTextStyle}>
                  Showing {startRow} to {endRow} of {count} entries
                </span>
              )}
            </div>

            {this.renderPaginationButtons()}
          </>
        ) : (
          <div style={flexBetweenStyle}>
            <div style={leftSectionStyle}>
              <select
                style={selectStyle}
                value={rowsPerPage}
                onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
              >
                {[25, 50, 100].map((size) => (
                  <option key={size} value={size}>
                    {size} per page
                  </option>
                ))}
              </select>

              {count > 0 && (
                <span style={infoTextStyle}>
                  Showing {startRow} to {endRow} of {count} entries
                </span>
              )}
            </div>

            {this.renderPaginationButtons()}
          </div>
        )}
      </div>
    );
  }
}

export default Pagination;